import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-use';
import BannerImg from '../../../../public/assets/images/BannersFiles/27.jpg';
import StaticBanner from '../../../components/elements/StaticBanner';
import { PageHitCountApi } from '../../../shared/Helper';

const BoardofDirectors = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);

  return (
    <>
      <div className="">
        <StaticBanner BannerImg={BannerImg} en_US={'Board of Directors'} arabic={false} />
        <h2 className={`text-customgreen sm:text-3xl text-center font-bold py-3`}>{t('Chairman’s Message')}</h2>
        <div className="flex flex-col  lg:flex-row justify-center items-center ">
          <div className="w-1/2 pb-4  flex justify-center items-center ">
            <img
              src={`/assets/images/chairman.png`}
              className=" w-full h-auto max-h-[500px] object-contain"
              alt="image"
            />
          </div>
          <section
            className={`lg:w-1/2 flex xl:flex-row flex-col py-1 px-3 lg:px-12 ${isActive ? 'text-left' : 'text-right'}`}
          >
            <div className="px-4">
              <h4
                className={`text-customgreen flex sm:text-2xl lg:pt-10 text-justify  ${isActive ? 'justify-right' : 'justify-left'} `}
              >
                {isActive
                  ? `  استطاعت جمعية الشارقة الخيرية منذ تأسيسها سنة 1989 أن تترجم مفاهيم الإنسانية في أبهى صورها وها نحن نحصد ما
              غرسه المحسنون في أرض خصبة، أثمرت الآف المشاريع الخيرية التي حققت أهدافها في تمكين المستفيدين من الاعتماد
              على أنفسهم لتغدو خطوة في مفهوم الاستدامة سبقت لها شارقة الخير واستثمرت في ترسيخها المشاريع التي تلامس
              احتياجات الناس بشكل مباشر.`
                  : `Since its establishment in 1989, Sharjah Charity Association has translated humanitarian concepts into their most beautiful forms. We are now reaping the benefits of what benefactors have sown in fertile ground, resulting in thousands of charitable projects that have achieved their goals by enabling beneficiaries to become self-reliant, making strides in the concept of sustainability that Sharjah Al-Khair pioneered through projects that directly address people's needs.`}
              </h4>
              <h2
                className={`text-customgreen sm:text-2xl ${isActive ? 'text-right' : 'text-left'} underline font-semibold pt-2`}
              >
                {t('Board Members')}
              </h2>
              <div
                className={`text-customgreen flex sm:text-2xl pb-5 pt-6 text-justify  ${isActive ? 'justify-right' : 'justify-left'} `}
              >
                <ul class="list-disc ml-4 sm:text-2xl">
                  <li>
                    {isActive
                      ? `الشيخ صقر بن محمد القاسمي: رئيس مجلس الإدارة  (مرفق صورة رئيس مجلس الإدارة`
                      : `Al Sheikh Saqr bin Mohammed Al Qasimi: Chairman`}
                  </li>
                  <li>
                    {isActive
                      ? `محمد راشد بن بيات: نائب رئيس مجلس الإدارة`
                      : `Mohammed Rashid bin Biyat: Vice Chairman`}
                  </li>
                  <li>{isActive ? `سعيد غانم السويدي: عضو مجلس الإدارة` : `Saeed Ghanem Al-Suwaidi: Board Member`}</li>
                  <li>{isActive ? `صالح محمد سعيد القابض الطنيجي.` : `Saleh Mohammed Said Al-Qabid Al-Taniji`}</li>
                  <li>{isActive ? `د.يعقوب علي سعيد خلف النقبي` : `Dr. Yaqoub Ali Said Khalfan Al-Naqbi`}</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default BoardofDirectors;
